import { GET, POST } from "./common/http";
import { BASE_URL } from "./common/const";

export const GetCountryList = (params: any) =>
  GET(`${BASE_URL}/api/Country/GetList?` + params, null);

  export const GetCountryListForSelect = (params: any) =>
  GET(`${BASE_URL}/api/Country/GetListForSelect?` + params, null);